import { render } from "./BillingView.vue?vue&type=template&id=1c2c399e&scoped=true&ts=true"
import script from "./BillingView.vue?vue&type=script&lang=ts"
export * from "./BillingView.vue?vue&type=script&lang=ts"

import "./BillingView.vue?vue&type=style&index=0&id=1c2c399e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2c399e"]])

export default __exports__